import { Palette, X } from "lucide-react";
import { DesignOptions } from "./DesignOptions";

type MobileBottomSheetProps = {
  isOpen: boolean;
  onClose: () => void;
  selectedTemplate: string | null;
  selectedStyle: string | null;
  selectedOrientation: string;
  selectedColors: string;
  onTemplateChange: (templateId: string) => void;
  onStyleChange: (styleId: string) => void;
  onOrientationChange: (orientationId: string) => void;
  onColorsChange: (colorsId: string) => void;
};

export const MobileBottomSheet = ({
  isOpen,
  onClose,
  selectedTemplate,
  selectedStyle,
  selectedOrientation,
  selectedColors,
  onTemplateChange,
  onStyleChange,
  onOrientationChange,
  onColorsChange
}: MobileBottomSheetProps) => (
  <div
    className={`z-1000000000 fixed inset-0 transition-all duration-300 ${isOpen ? "pointer-events-auto" : "pointer-events-none"}`}
  >
    <div
      onClick={onClose}
      className={`absolute inset-0 bg-black transition-opacity duration-300 ${isOpen ? "opacity-50" : "opacity-0"}`}
    />

    <div
      className={`absolute bottom-0 left-0 right-0 max-h-full transform rounded-t-2xl bg-white shadow-xl transition-transform duration-300 ${isOpen ? "translate-y-0" : "translate-y-full"}`}
      role="dialog"
      aria-modal="true"
      aria-hidden={!isOpen}
      aria-labelledby="mobile-sheet-title"
      data-testid="mobile-bottom-sheet"
    >
      <div className="flex justify-center pb-2 pt-3">
        <div className="h-1 w-12 rounded-full bg-gray-300" />
      </div>

      <div className="flex items-center justify-between px-6 pb-4">
        <h2 id="mobile-sheet-title" className="flex items-center gap-2 text-lg font-semibold">
          <Palette className="h-5 w-5 text-indigo-600" />
          Design Options
        </h2>
        <button
          data-testid="mobile-sheet-close-button"
          onClick={onClose}
          className="rounded-lg p-2 transition-colors hover:bg-gray-100"
          aria-label="Close design options"
        >
          <X className="h-5 w-5 text-gray-500" />
        </button>
      </div>

      <div className="max-h-[calc(100vh-78px)] overflow-y-auto px-4 pb-4">
        <DesignOptions
          selectedTemplate={selectedTemplate}
          selectedStyle={selectedStyle}
          selectedOrientation={selectedOrientation}
          selectedColors={selectedColors}
          onTemplateChange={onTemplateChange}
          onStyleChange={onStyleChange}
          onOrientationChange={onOrientationChange}
          onColorsChange={onColorsChange}
          showTitle={false}
        />
      </div>
    </div>
  </div>
);
